import { createSlice } from '@reduxjs/toolkit'

export type PortalSessionResetState = {
    requestCount: number
}

const initialState: PortalSessionResetState = {
    requestCount: 0,
}

const portalSessionResetSlice = createSlice({
    name: 'portalSessionReset',
    initialState,
    reducers: {
        requestPortalSessionReset: (state) => {
            state.requestCount += 1
        },
    },
})

export const { requestPortalSessionReset } = portalSessionResetSlice.actions

export const selectPortalSessionResetRequestCount = (state: { portalSessionReset: PortalSessionResetState }): number =>
    state.portalSessionReset.requestCount

export default portalSessionResetSlice.reducer
